import { useQuery } from "@tanstack/react-query";
import { fetchNotifications, NOTIFICATIONS_QUERY_KEY } from "../api/notifications";

export function useNotifications(opts?: { includeDismissed?: boolean; enabled?: boolean }) {
  return useQuery({
    queryKey: [...NOTIFICATIONS_QUERY_KEY, opts?.includeDismissed ?? false],
    queryFn: () => fetchNotifications(opts?.includeDismissed ?? false),
    staleTime: 30_000,
    // The nav bell keeps this query mounted for the life of the tab, and
    // refetchOnWindowFocus is off globally, so without a poll a delivered
    // push never moves the badge or an open Notifications page. The server's
    // ETag fast path on GET /api/notifications exists for exactly this 30s
    // poll: an unchanged feed costs a 304, not a full read. Polling pauses in
    // background tabs (refetchIntervalInBackground defaults to false).
    refetchInterval: 30_000,
    enabled: opts?.enabled ?? true,
  });
}

export function useUnreadNotificationCount(opts?: { enabled?: boolean }) {
  const query = useNotifications({ enabled: opts?.enabled });
  const unread = (query.data ?? []).filter((n) => n.dismissedAt === null).length;
  return { count: unread, ...query };
}
